import * as loweringDeliveryAction from '../actions/loweringDeliveryAction';
import { endLoading, startLoading } from '../actions/loadingAction';
import { getUrlExpeditionApi, showMessageToastCustom, translate } from '../utils/util';
import HttpService from './HttpService';

const httpService = new HttpService(getUrlExpeditionApi(window));

export default class LoweringDeliveryService {
    static getOrdersDeliverys(filter, callback) {
        const url = '/api/loweringDelivery/filter';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(loweringDeliveryAction.setOrders(response.data?.data));
                        if (callback) {
                            callback(response.data?.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static checkedItem(orderItemId, callback) {
        const url = `/api/loweringDelivery/checkeditem/${orderItemId}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback()
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static ConfirmationDeliveryPdu(orderId, location, callback) {
        const url = `/api/loweringDelivery/confirmation?location=${location}&orderId=${orderId}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(loweringDeliveryAction.updateOrder(response.data?.data));
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static leave(orderGroupId, callback) {
        const url = `/api/loweringDelivery/ordergroup/leave`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderGroupId: orderGroupId, leave: true }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }
}
